/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import * as Yup from "yup";
import jwtDecode from "jwt-decode";
import { useFormik } from "formik";
import { login } from "../core/_requests";
import { toAbsoluteUrl } from "../../../../_mcp/helpers";
import { useAuth } from "../core/Auth";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import clsx from "clsx";
import { encryptAES256CBC, decryptAES256CBC } from "../utils/encryption";
import { getCookie } from "../utils/cookie-utils";

const loginSchema = Yup.object().shape({
  userName: Yup.string().required("username is required"),
  tokenLogin: Yup.string().required("username is required"),
});

const initialValues = {
  userName: "",
  tokenLogin: "",
};

export function Login() {
  const { saveAuth, setCurrentUser } = useAuth();
  const alert = withReactContent(Swal);
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        setSubmitting(true);

        // Encrypt the password before sending to API
        const encryptedPassword = encryptAES256CBC(values.tokenLogin);

        // Create payload with encrypted password
        const loginPayload = {
          userName: values.userName,
          tokenLogin: encryptedPassword,
        };

        const response = await login(loginPayload);
        // Get encrypted payload from response body
        const encryptedPayload = (response.detailData as any)?.encryptedPayload;

        if (!encryptedPayload) {
          throw new Error("Encrypted payload token not found in response");
        }

        // Decrypt the payload
        const decryptedPayloadString = decryptAES256CBC(encryptedPayload);
        console.log("Decrypted payload string:", decryptedPayloadString);

        const decryptedPayload = JSON.parse(decryptedPayloadString);
        console.log("Decrypted payload object:", decryptedPayload);

        // Create auth data object without accessToken (backend reads from httpOnly cookie)
        const authData = {
          ...decryptedPayload,
        };

        saveAuth(authData);
        setCurrentUser({
          username: decryptedPayload.userName,
          auth: authData,
        });
      } catch (error) {
        saveAuth(undefined);
        setStatus("The login details are incorrect");
        alert.fire({
          text: "Sorry looks like there are some errors detected, please try again.",
          icon: "error",
          padding: "7px 50px 30px 50px",
          heightAuto: false,
          showConfirmButton: false,
        });
      }
    },
  });

  return (
    <>
      <form
        className="form w-100 mb-13"
        onSubmit={formik.handleSubmit}
        noValidate
        id="kt_login_signin_form"
      >
        <div className="text-center mb-10">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/auth/phone.png")}
            className="mh-125px"
          />
        </div>
        <div className="text-center mb-10">
          <h1 className="text-dark mb-3">Security Verification</h1>
          <div className="text-muted fw-semibold fs-5 mb-5 text-capitalize">
            enter username & password we sent to your email
          </div>
        </div>
        <div className="row g-9 mb-8">
          <div className="col-md-12 fv-row">
            <label className="fs-5 fw-semibold mb-2">Username</label>
            <input
              {...formik.getFieldProps("userName")}
              type="text"
              name="userName"
              className={clsx("form-control form-control-lg mb-3 mb-lg-0", {
                "is-invalid": formik.touched.userName && formik.errors.userName,
              })}
              autoComplete="off"
              disabled={formik.isSubmitting}
            />
          </div>
          <div className="col-md-12 fv-row">
            <label className="fs-5 fw-semibold mb-2">Password</label>
            <div className="position-relative">
              <input
                {...formik.getFieldProps("tokenLogin")}
                type={showPassword ? "text" : "password"}
                name="tokenLogin"
                className={clsx("form-control form-control-lg mb-3 mb-lg-0", {
                  "is-invalid":
                    formik.touched.tokenLogin && formik.errors.tokenLogin,
                })}
                autoComplete="off"
                disabled={formik.isSubmitting}
              />
              <button
                type="button"
                className="btn btn-link position-absolute top-50  end-0 translate-middle-y pe-3"
                onClick={() => setShowPassword(!showPassword)}
                disabled={formik.isSubmitting}
                style={{
                  border: "none",
                  background: "none",
                  padding: "0",
                  color: "#6c757d",
                  marginRight: formik.errors.tokenLogin ? "30px" : "10px",
                  zIndex: 10,
                }}
              >
                {showPassword ? (
                  <i className="fas fa-eye-slash"></i>
                ) : (
                  <i className="fas fa-eye"></i>
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex flex-center">
          <button
            type="submit"
            className="btn btn-lg btn-primary fw-bold w-100"
            disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            {!formik.isSubmitting && (
              <span className="indicator-label">Submit</span>
            )}
            {formik.isSubmitting && (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
        </div>
      </form>
      {/* <div className='text-center fw-semibold fs-5'>
        <span className='text-muted me-1'>Didn’t get the code ?</span>
        <Link to='/auth/forgot-password' className='link-primary fs-5 me-1'>
          Resend Code
        </Link>
      </div> */}
    </>
  );
}
